import React, { useState, useEffect } from "react";
import { CardBody, TabContent, TabPane, Col, Container, Row, Input, Label, Button, Form } from "reactstrap";
import Layout from "../../HorizontalMenu/Menu";
import Navbar from "../../HorizontalMenu/Navbar";
import '../../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../';
import { VesselState, setVesselState } from "../../Store/Generic/ReportingSlice";
import VesselDetailsHeader from "../../Components/VesselDetailsHeader";
import ReportDetailsHeader from "../../Components/ReportDetailsHeader";
import apiGlobal from "../../global/api.global";
import { useQuery } from "react-query";
import { CIIAdjustmentType } from '../../shared/dataTypes';
import { queryKeyes } from "../../shared/queryKeys";
import CIIAdjustmentModal from "./ReportComponents/CIIAdjustmentModal";
import CIIAdjustmentFileUpload from "../../Components/CIIAdjustmentFileUpload";
import ReportingCIIAdjustmentEndModal from "../../Components/ReportingCIIAdjustmentEndModal";
import { EngineStatus, VesselTypeConstant } from "../../shared/constants";
import { allDecofficerReport, PreviousVesselReportingInfo } from "../../VesselMaster/vesselMaster.hooks";
import { CpWarrantyComponent } from "./ReportComponents/CpWarrantyComponent";
import ToolTip from "../../Components/ToolTip";
import { errorToast, successToast } from "../../Components/Toasts";
import PopOver from "Components/PopOver";
import DraftsCargoLadingComponent from "./ReportComponents/DraftsCargoLadingComponent";
import STSOperationComponent from "./ReportComponents/STSOperationComponent";
import ETADComponent from "./ReportComponents/ETADComponent";
import LfondsAddInformation from "./AdditionalInformation/Lfonds/LfondsAddInformation";
import Loading from "Components/Loading";
import ErrorComponent from "Components/ErrorComponent";
import { errResponse } from "GenericForms/Helper";
import WeatherData from "./ReportComponents/WeatherData";
import DeletePopOver from "Components/DeletePopOver";

const DeckOfficerWizard = () => {
    const [activeTab, setactiveTab] = useState(1);
    const [modalBackdropCIIStart, setModalBackDropCIIStart] = useState(false);
    const [modalBackdropCIIEnd, setModalBackDropCIIEnd] = useState(false);
    const [modalBackdropCIIUpload, setmodalBackdropCIIUpload] = useState(false);
    const [modalBackdropCIIResume, setmodalBackdropCIIResume] = useState(false);
    const [lastRecord, setLastRecord] = useState({ created_on: '', arrival_datetime: '', arrival_port: '', departure_port: '', departure_datetime: '', reporting_time_utc: '' });
    const [weatherDataId] = useState(1);
    const [CIIAdjustmentId] = useState(2);
    const [stsId] = useState(3);
    const [CPWarrantiesId] = useState(4);
    const [DDCDBLId] = useState(5);
    const [ETAId] = useState(6);
    const [LfondsId] = useState(7);
    const [lastTabId] = useState(8);
    const [CIIAdjustmentEvents, setCIIAdjustmentEvents] = useState<Array<CIIAdjustmentType>>([]);
    const [CIIEventsList, setCIIEventsList] = useState<Array<any>>([]);
    const [eventState, setEventState] = useState<any>({});
    const [popoverState, setPopoverState] = useState(false);
    const dispatch = useDispatch();
    const { VesselID, VoyageID, ReportID, Reports, Vessels } = useSelector((state: RootState) => state.Reporting);
    let record = Reports.find((rec: any) => rec.id === ReportID) ?? null;
    let vessel = Vessels.find((rec: any) => rec.id === VesselID) ?? null;

    const allReport = useQuery([queryKeyes.vessel.decOfficerAll.key, ReportID],
        async () => { return await allDecofficerReport(ReportID) }, {
        enabled: true,
    });

    const [CIIAdjustmentData, setCIIAdjustmentData] = useState<Array<CIIAdjustmentType>>([]);
    function toggleTab(tab: any) {
        if (activeTab !== tab) {
            if (tab >= 1 && tab <= lastTabId) {
                setactiveTab(tab);
            }
        }
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    const togBackDropCIIStart = () => {
        setModalBackDropCIIStart(!modalBackdropCIIStart);
        loadCIIAdjustmentEvents();
        removeBodyCss();
    }

    const togBackDropCIIEnd = (event: any) => {
        setEventState(event)
        setModalBackDropCIIEnd(!modalBackdropCIIEnd);
        removeBodyCss();
    }

    const togBackDropCIIUpload = (event: any) => {
        setEventState(event)
        loadCIIAdjustmentEvents();
        setmodalBackdropCIIUpload(!modalBackdropCIIUpload);
        removeBodyCss();
    }

    const togBackDropCIIResume = (event: any) => {
        setEventState(event)
        loadCIIAdjustmentEvents();
        setmodalBackdropCIIResume(!modalBackdropCIIResume);
        removeBodyCss();
    }

    useEffect(() => {
        const loadCIIEventsList = async () => {
            await apiGlobal.get(`/cii_adjustment_events_master`).then(res => {
                setCIIEventsList(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            })
        }; loadCIIEventsList();
    }, []);

    const loadCIIAdjustmentEvents = async () => {
        await apiGlobal.get(`/vessel_reporting_cii_adjustment/get_cii_adjustment_by_vessel/?vessel_id=${VesselID}`).then(res => {
            setCIIAdjustmentEvents(res.data);
            return res.data;
        }).catch(err => {
            if (errResponse.includes(err.response.status)) {
                errorToast("Internal error occured, please contact the admin");
            }
        })
    }

    useEffect(() => {
        loadCIIAdjustmentEvents();
    }, [VesselID]);

    useEffect(() => {
        const loadLastRecord = async () => {
            await apiGlobal.get(`/vessel_reporting_information/get_previous_by_id/?id=${ReportID}&vessel_id=${VesselID}`).then(res => {
                setLastRecord(res.data);
                return res.data;
            }).catch(err => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            })
        }; loadLastRecord();
    }, [ReportID, VesselID]);

    const { data: PreviousVesselReport, isLoading: PreviousVesselReportLoading, isError: PreviousVesselReportError } = useQuery(
        [queryKeyes.vessel.PreviousVesselReport.key, VesselID, ReportID],
        () => PreviousVesselReportingInfo(ReportID, VesselID),
        { staleTime: Infinity });

    const handleResponse = (response: any) => {
        if (response.status === 201 || response.status === 200) {
            successToast("Data saved successfully!");
        }
    }

    const RemarksSubmit = async () => {
        let report = { ...record }
        report.officer_reporting_status = 2;
        try {
            const response = await apiGlobal.put(`/vessel_reporting_information/${ReportID}/`, report);
            handleResponse(response);
            return response.data
        } catch (err) {
            return null;
        }
    }

    const handleVesselState = (record: VesselState) => {
        dispatch(setVesselState(record))
    }

    const handleSaveandComplete = async () => {
        let report = { ...record }
        report.officer_reporting_status = 3;
        try {
            const response = await apiGlobal.put(`/vessel_reporting_information/${ReportID}/`, report);
            handleResponse(response);
            handleVesselState('VESSEL_REPORTING');
            return response.data;
        } catch (err) {
            return null;
        }
    }

    const resumeCIIEndEvent = async (event: any) => {
        event.cii_adjustment_end_event = null;
        event.cii_end_report = null;
        event.cii_end_date_time = null;
        event.cii_adjustment_status = true;
        try {
            const response = await apiGlobal.put(`/vessel_reporting_cii_adjustment/${event.id}/`, event);
            if (response.data) {
                handleResponse(response);
                setmodalBackdropCIIResume(false);
                loadCIIAdjustmentEvents();
            }
            return response.data;
        } catch (err) {
            return null;
        }
    }

    /** Function to delete CII Adjustment event */
    const handleAdjustmentEventDelete = (id: number) => {
        apiGlobal.delete(`/vessel_reporting_cii_adjustment/${id}/`).then(res => {
            if (res.status === 200 || res.status === 204) {
                successToast("Data deleted successfully!");
                loadCIIAdjustmentEvents();
                setPopoverState(false);
            }
        }).catch(err => {
            if (errResponse.includes(err.response.status)) {
                errorToast("Internal error occured, please contact the admin");
            }
        });
    }

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <div className="page-content" style={{ paddingTop: '2rem' }}>
                <Container fluid>
                    <CardBody>
                        <Row>
                            <Col>
                                <button color='primary' className='btn btn-primary mb-3' onClick={() => { handleVesselState('VESSEL_REPORTING') }}><i className="bx bx-chevron-left me-1" /> Back</button>
                            </Col>
                            <Col>
                                <div className="pos-end">
                                    <VesselDetailsHeader />
                                </div>
                            </Col>
                        </Row>
                        {PreviousVesselReportLoading && <Loading message='Loading required data!' />}
                        {PreviousVesselReportError && <ErrorComponent message='Unable to load required data!' />}
                        {!PreviousVesselReportLoading && !PreviousVesselReportError &&
                            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                                <TabContent
                                    activeTab={activeTab}
                                >
                                    <TabPane tabId={weatherDataId} className="tabHeight">
                                        {allReport.isLoading ? <div className="alert alert-info" role="alert">
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Data is loading please wait!
                                        </div> : ''}
                                        <WeatherData
                                            lastReocrd={lastRecord}
                                            record={record}
                                            vessel={vessel}
                                            VesselID={VesselID}
                                            VoyageID={VoyageID}
                                            ReportID={ReportID}
                                            activeTab={activeTab}
                                            toggleTab={toggleTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId={CIIAdjustmentId} className="tabHeight">
                                        <div className="text-center mb-4">
                                            <Row>
                                                <Col>
                                                    <h4 className="page_title pos-start mb-0">CII Adjustment Events</h4>
                                                    <p className="card-title-desc pos-start">All readings since last report</p>
                                                </Col>
                                                <Col>
                                                    <ReportDetailsHeader />
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row className="mb-3">
                                            <Col lg={12}>
                                                <Button color='primary' className='btn btn-primary justify_right' onClick={togBackDropCIIStart}><i className="dripicons-plus font-size-16 align-middle me-2"></i>
                                                    Create New
                                                </Button>
                                                <CIIAdjustmentModal
                                                    state={modalBackdropCIIStart}
                                                    setState={setModalBackDropCIIStart}
                                                    ongoingEvents={CIIAdjustmentEvents.filter((item: any) => item.cii_adjustment_status === true)}
                                                    CIIData={CIIAdjustmentData}
                                                    setCIIData={setCIIAdjustmentData}
                                                    record={record}
                                                    loadCIIAdjustments={loadCIIAdjustmentEvents}
                                                    reportId={ReportID}
                                                    vesselId={VesselID}
                                                    adjustmentEvents={CIIAdjustmentEvents.filter((item: any) =>
                                                        item.cii_begin_date_time <= record?.reporting_time_utc &&
                                                        (item.cii_end_date_time >= record?.reporting_time_utc || item.cii_end_date_time === null))}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            {CIIAdjustmentEvents.length > 0 ?
                                                <CardBody>
                                                    <div className="table-responsive" id='owner_table'>
                                                        <table className="table mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th>Sr. No.</th>
                                                                    <th>Current CII adjustment event(s)</th>
                                                                    <th>Start time</th>
                                                                    <th>End Time</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {CIIAdjustmentEvents.length > 0 ?
                                                                    CIIAdjustmentEvents.filter((item: any) =>
                                                                        item.cii_begin_date_time <= record?.reporting_time_utc &&
                                                                        (item.cii_end_date_time >= record?.reporting_time_utc || item.cii_end_date_time === null)).map((event: any, index: number) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{event.cii_adjustment_name}</td>
                                                                                    <td>{event?.cii_begin_date_time?.toString().substring(0, 10)} {event?.cii_begin_date_time?.toString().substring(11, 16)}</td>
                                                                                    <td>{event?.cii_end_date_time?.toString().substring(0, 10)} {event?.cii_end_date_time?.toString().substring(11, 16)}</td>
                                                                                    <td>{
                                                                                        <>
                                                                                            {event.cii_begin_date_time && event.cii_begin_date_time === record?.reporting_time_utc &&
                                                                                                <>
                                                                                                    <i className='dripicons-trash icon_s18' id='delete_cii_adjustment' onClick={() => setPopoverState(true)} />
                                                                                                    <ToolTip target='delete_cii_adjustment' message={`Delete ${event.cii_adjustment_name}`} />
                                                                                                    <DeletePopOver target='delete_cii_adjustment' onClick={() => handleAdjustmentEventDelete(event.id)} state={popoverState} />
                                                                                                </>
                                                                                            }
                                                                                            {(!event.cii_end_date_time && event.cii_begin_date_time !== record?.reporting_time_utc &&
                                                                                                <>
                                                                                                    <Button type="button" color="danger" onClick={() => togBackDropCIIEnd(event)}>End</Button>
                                                                                                    <ReportingCIIAdjustmentEndModal state={modalBackdropCIIEnd} setState={setModalBackDropCIIEnd} eventName={event.cii_adjustment_name} CIIData={event} CIIEvents={CIIEventsList} reportId={ReportID} record={record} />
                                                                                                </>
                                                                                            )}
                                                                                            {(event.cii_end_date_time &&
                                                                                                <>
                                                                                                    <ToolTip target="cii_documents" message="Upload CII documents" />
                                                                                                    <ToolTip target="cii_event_resume" message="Resume event" />
                                                                                                    <i className="ml-1 dripicons-upload icon_s18 pointer" onClick={() => togBackDropCIIUpload(event)} id="cii_documents" />
                                                                                                    <i className="ml-1 bx bx-undo icon_s23 pointer" onClick={(e: any) => togBackDropCIIResume(event)} id="cii_event_resume" />
                                                                                                    <PopOver
                                                                                                        target="cii_event_resume"
                                                                                                        handleClick={() => resumeCIIEndEvent(eventState)}
                                                                                                        message={`Are you sure you want to resume ${eventState?.cii_adjustment_name} event?`}
                                                                                                        state={modalBackdropCIIResume}
                                                                                                    />
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    }
                                                                                    </td>

                                                                                </tr>
                                                                            )
                                                                        }) : null}
                                                            </tbody>
                                                        </table>
                                                        {eventState && eventState?.id && <CIIAdjustmentFileUpload
                                                            state={modalBackdropCIIUpload}
                                                            event={eventState}
                                                            togBackDropCIIUpload={togBackDropCIIUpload}
                                                        />}
                                                        {eventState && eventState?.id && <ReportingCIIAdjustmentEndModal
                                                            state={modalBackdropCIIEnd}
                                                            event={eventState}
                                                            CIIEvents={CIIEventsList}
                                                            reportId={ReportID}
                                                            record={record}
                                                            loadCIIAdjEvent={loadCIIAdjustmentEvents}
                                                        />}
                                                    </div>
                                                </CardBody>
                                                : <Label className="text-center">Currently no CII adjustment events are in progress</Label>
                                            }
                                        </Row>
                                        <Row className="ele_row1">
                                            <div className="d-flex flex-wrap gap-5 mt-3 btn_Margin">
                                                <Button type="submit" color="primary" className="btn_size_cstm pos-end" onClick={(e) => {
                                                    toggleTab(activeTab + 1);
                                                }}>Next <i className="bx bx-chevron-right ms-1" /></Button>
                                                <Button type="button" color="primary" className="btn_size_cstm pos-start-0_75" onClick={(e) => {
                                                    toggleTab(activeTab - 1);
                                                }}><i className="bx bx-chevron-left me-1" /> Previous</Button>
                                            </div>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId={vessel && record &&
                                        (vessel?.vessel_type === VesselTypeConstant.TANKER && record?.is_sts_considered === true) ? stsId : 0}
                                        className="tabHeight">
                                        <STSOperationComponent
                                            record={record}
                                            lastRecord={PreviousVesselReport}
                                            VesselID={VesselID}
                                            ReportID={ReportID}
                                            activeTab={activeTab}
                                            toggleTab={toggleTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId={((record && record.status_name === EngineStatus.ringFullAway) &&
                                        (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER && record?.is_sts_considered === true)) ? CPWarrantiesId :
                                        (((record && record.status_name === EngineStatus.ringFullAway) &&
                                            (vessel && vessel?.vessel_type !== VesselTypeConstant.TANKER)) ||
                                            ((record && record.status_name === EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER && record?.is_sts_considered === false))) ?
                                            CPWarrantiesId - 1 : - 1} className="tabHeight">
                                        <CpWarrantyComponent
                                            VesselID={VesselID}
                                            VoyageID={VoyageID}
                                            ReportID={ReportID}
                                            record={record}
                                            toggleTab={toggleTab}
                                            activeTab={activeTab}
                                            CPWarrantySpeedDataObject={allReport?.data?.cp_warranties_speed}
                                            CpWarrantyFuelObject={allReport?.data?.cp_warranties_fuel}
                                            lastRecord={lastRecord}
                                            vessel={vessel}
                                        />
                                    </TabPane>
                                    <TabPane tabId={((record && record.status_name === EngineStatus.ringFullAway) &&
                                        (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER && record?.is_sts_considered === true)) ? DDCDBLId :
                                        (((record && record.status_name === EngineStatus.ringFullAway) &&
                                            (vessel && vessel?.vessel_type !== VesselTypeConstant.TANKER)) ||
                                            ((record && record.status_name === EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === false) ||
                                            ((record && record.status_name !== EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true)) ? DDCDBLId - 1 : DDCDBLId - 2}>
                                        <DraftsCargoLadingComponent
                                            record={record}
                                            vessel={vessel}
                                            VesselID={VesselID}
                                            VoyageID={VoyageID}
                                            ReportID={ReportID}
                                            activeTab={activeTab}
                                            toggleTab={toggleTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId={((record && record.status_name === EngineStatus.ringFullAway) &&
                                        (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true) ? ETAId :
                                        (((record && record.status_name === EngineStatus.ringFullAway) &&
                                            (vessel && vessel?.vessel_type !== VesselTypeConstant.TANKER)) ||
                                            ((record && record.status_name === EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === false) ||
                                            ((record && record.status_name !== EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true)) ? ETAId - 1 : ETAId - 2}>
                                        <ETADComponent
                                            ReportID={ReportID}
                                            VesselID={VesselID}
                                            VoyageID={VoyageID}
                                            activeTab={activeTab}
                                            record={record}
                                            lastRecord={lastRecord}
                                            toggleTab={toggleTab}
                                            etaDataobject={allReport?.data?.expected_time_of_arrival}
                                            key="ETADComponent"
                                        />
                                    </TabPane>
                                    <TabPane tabId={((record && record.status_name === EngineStatus.ringFullAway) &&
                                        (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true) ? LfondsId :
                                        (((record && record.status_name === EngineStatus.ringFullAway) &&
                                            (vessel && vessel?.vessel_type !== VesselTypeConstant.TANKER)) ||
                                            ((record && record.status_name === EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === false) ||
                                            ((record && record.status_name !== EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true)) ? LfondsId - 1 : LfondsId - 2}>
                                        <LfondsAddInformation
                                            ReportID={ReportID}
                                            VesselID={VesselID}
                                            VoyageID={VoyageID}
                                            activeTab={activeTab}
                                            toggleTab={toggleTab}
                                            record={record}
                                            vessel={vessel}
                                        />
                                    </TabPane>
                                    <TabPane tabId={((record && record.status_name === EngineStatus.ringFullAway) &&
                                        (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true) ? lastTabId :
                                        (((record && record.status_name === EngineStatus.ringFullAway) &&
                                            (vessel && vessel?.vessel_type !== VesselTypeConstant.TANKER)) ||
                                            ((record && record.status_name === EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === false) ||
                                            ((record && record.status_name !== EngineStatus.ringFullAway) &&
                                                (vessel && vessel?.vessel_type === VesselTypeConstant.TANKER) && record?.is_sts_considered === true)) ? lastTabId - 1 : lastTabId - 2}>
                                        <div className="text-center mb-4">
                                            <Row>
                                                <Col>
                                                    <h5 className="page_title pos-start mb-0">Remarks(if any)</h5>
                                                </Col>
                                                <Col>
                                                    <ReportDetailsHeader />

                                                </Col>
                                            </Row>
                                        </div>
                                        <Form className="needs-validation"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                RemarksSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="form-floating mb-3 input-group">
                                                        <Input
                                                            type="textarea"
                                                            className="form-control"
                                                            id="textarea"
                                                            name="remarks"

                                                        />
                                                        <Label for="cargo_detail">Remarks</Label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="ele_row1">
                                                <div className="d-flex flex-wrap gap-5 mt-3 btn_Margin">
                                                    <Button type="submit" color="primary" className="btn_size_cstm pos-end12">Save</Button>
                                                    <Button type="button" color="primary" className="btn_size_cstm pos-end" onClick={(e) => {
                                                        handleSaveandComplete();
                                                    }}>Save & Complete</Button>
                                                    <Button type="button" color="primary" className="btn_size_cstm pos-start-0_75" onClick={(e) => {
                                                        toggleTab(activeTab - 1);
                                                    }}><i className="bx bx-chevron-left me-1" /> Previous</Button>
                                                </div>
                                            </Row>
                                        </Form>
                                    </TabPane>
                                </TabContent>
                            </div>
                        }
                    </CardBody>
                </Container>
            </div>
        </React.Fragment >
    );
};

export default DeckOfficerWizard;
